export default function ShowConditional({ condition, children, ...props }) {
	return <div {...props} style={{ ...props.style, display: condition ? null : 'none' }}>
		{children}
	</div>;
}